<template>
    <component v-if="currentComponent !== 'ErrorPage' && currentComponent !== 'ComingSoon'" :is="JFCLayout">
        <component :is="currentComponent" v-bind="currentProps" />
    </component>
    <component v-else :is="currentComponent" v-bind="currentProps" />
</template>

<script>
import {checkFonts} from "../../settingsEditor/_helpers/fontLoaders.js";
import GoogleFontsHelper from "../../common/GoogleFontsHelper.js";
import ApiHelper from "../../api/ApiHelper.js";

//Pages
import PortfolioPage from "../portfolio/Portfolio.vue";
import Project from "../portfolio/Project.vue"
import CustomPage from "../portfolio/Page.vue";
import PasswordProtection from "../portfolio/common/PasswordProtection.vue";
import ErrorPage from "../common/ErrorPage.vue";
import ComingSoon from "../../common/ComingSoon.vue";
import {mapGetters} from "vuex";
import JFCLayout from "./JFCLayout.vue";
import {UserActions} from "../../store/actions/UserActions.js";

export default {
    name: "JFCWrapper",
    components: {
        PortfolioPage,
        Project,
        CustomPage,
        PasswordProtection,
        ErrorPage,
        ComingSoon
    },
    data() {
        return {
            loaded: false,
            pageType: null,
            projectShortId:null,
            error:false
        }
    },
    async mounted() {
        try {
            await this.$store.dispatch('jfc/fetchPreviousJFCResults');
        } catch (e) {
            console.error("Can't get previous results", e);
        }
    },
    //This runs if user don't have owndomain adress
    async beforeRouteEnter(to, from, next) {
        try {
            let url = '/data'
            const portfolioShortId = to.params.portfolioShortId;

            if(portfolioShortId) {
                url += '/shortid/' + portfolioShortId
                if(to.params.projectShortId) {
                    url += '/' + to.params.projectShortId
                }
            }
            else {
                url += '/portfolio'
            }

            const res = await ApiHelper.get(url + "?isJFC=true");

            next(vm => vm.setData(res.status, res.data))
        }
        catch(err) {
            next(vm => vm.setData(err, null))
        }
    },
    async beforeRouteUpdate(to, from) {
        try {
            const url = this.projectFetchUrl(to)
            const res = await ApiHelper.get(url + "?isJFC=true");
            const data = res.data;
            this.setData(null, data);
        }
        catch(err) {
            console.log('error', err)
        }
    },
    methods: {
        setData(err, data) {
            if(err && !data) {
                if(err.response.status === 404) {
                    this.pageType = 'not_found'
                    this.error = true;
                    this.loaded = true;
                    return;
                } else if (err.response.status === 401) {
                    this.pageType = 'coming_soon';
                    this.loaded = true;
                    return;
                }
            }

            //Load fonts
            if(!this.viewData.fontsLoaded) {
                checkFonts(data.fonts)
                //load legacy fonts
                let legacyFonts = data.fontNames.filter((fontName) => !data.fonts.map(x => x.name).includes(fontName))
                legacyFonts.forEach((name) =>{
                    GoogleFontsHelper.getFontURL(name);
                })
                this.viewData.fontsLoaded = true;
            }

            this.password = false;

            let viewData = {
                portfolio:data.portfolio,
                project:data.project,
                user:data.user,
                portfolioPages:data.portfolioPages,
                activePage:data.project.shortId,
                caseStudies:data.caseStudies,
                hasDraftCasestudies:data.hasDraftCasestudies,
                loggedInUserId:data.loggedInUserId,
                emergencyModeSettings:data.emergencyModeSettings
            }

            if(viewData.loggedInUserId === data.project.ownerId) {
                UserActions.getUser()
            } else {

            }

            //Update current page
            if(data.project.type === 'home') {
                this.pageType = "portfolio";
            }
            else {
                if(data.project.type === 'caseStudy') {
                    this.pageType = "project";
                }
                else {
                    this.pageType = "custom"
                }
            }

            this.$store.commit('view/updateView', viewData);

            if(!data.portfolio.templateSettings.theme.includes('profile_')) {
                try {
                    import(`../../../styles/_${data.portfolio.templateSettings.theme.replaceAll('_', '-').replace('profile_', '')}-base.scss`);
                }
                catch (e) {
                    console.log('failed to import scss')
                }
            }

            //TODO: figure this ourt
            this.$store.state.portfolio = data.portfolio
            this.$store.state.project = data.project

            this.loaded = true;
        },
        projectFetchUrl(to) {
            const path = to.path;
            const portfolioShortId = to.params.portfolioShortId;
            const projectShortId = to.params.projectShortId;

            if (path.startsWith("/jobfitchecker/p/")) {
                let url = "/data/project/" + portfolioShortId;
                if (projectShortId) {
                    url += "/" + projectShortId;
                }
                return url;
            } else {
                return "/data/shortid/" + portfolioShortId;
            }
        }
    },
    computed: {
        JFCLayout() {
            return JFCLayout
        },
        ...mapGetters("view", ["viewData"]),
        currentComponent() {
            if (!this.loaded) return null;
            switch (this.pageType) {
                case 'project': return 'Project';
                case 'custom': return 'CustomPage';
                case 'not_found': return 'ErrorPage';
                case 'portfolio': return 'PortfolioPage';
                case 'coming_soon': return 'ComingSoon';
                default: return null;
            }
        },
        currentProps() {
            if (this.error) {
                return {
                    error: {
                        code: 404,
                        title: 'This page doesn’t exist',
                        message: 'We can’t seem to find the page you are looking for'
                    }
                };
            }
            if (this.pageType === 'coming_soon') {
                return { type: 'Case Study' };
            }
            return {};
        },
    }
}
</script>

<style lang="scss">
.jfc-wrapper {
    .ufo-sec--navigation {
        .sticky-header {
            &.sticked {
                top:60px;
            }
        }
    }
}
</style>